import React, { useState } from 'react';
import './FaqSection.css';

export const faqs = [
  {
    q: "Can Canadian citizens access your services?",
    a: "Yes. Canadian citizens — whether self-employed or employed through a corporation — can join directly. Many members come on their own; others are introduced by a family office or company. This is private-pay care. It sits alongside publicly insured services. It does not replace them, and it does not replace an emergency department when you truly need one.",
  },
  {
    q: "Can foreign nationals access your program?",
    a: "Yes. Members who live in Toronto for part of the year, or who need coordination while traveling, are welcome. Visits are arranged around your calendar. With your authorization, we can liaise with clinicians outside Canada.",
  },
  {
    q: "Do you accept families into the program?",
    a: "Yes. Household membership is built for spouses and dependent children. Records stay separate. The clinical team is shared, so the family history is finally in one place — without anyone becoming a footnote on someone else’s chart.",
  },
  {
    q: "Do you work with elderly patients?",
    a: "Yes. The clinic was founded by a geriatrician and internist. Older members receive the same preventive program, with particular attention to medications, mobility, cognition, and remaining independent at home.",
  },
  {
    q: "Are there any tax benefits to joining?",
    a: "We do not give tax, legal, or accounting advice. Some members ask their own advisor whether a corporate wellness arrangement can be reviewed as a business expense. That depends entirely on your facts. Please confirm with a qualified professional before you join for that reason.",
  },
];

function FaqSection() {
  // Default first question open (index 0) as seen in design
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="ttc-faq-section py-5">
      <div className="container py-md-4">
        <div className="row g-4 g-lg-5 align-items-stretch">
          
          {/* Left Column: Image with Overlay Quote */}
          <div className="col-12 col-lg-5">
            <div className="ttc-faq-image-card position-relative h-100 rounded-4 overflow-hidden">
              <img
                src="/images/creatives/landing-page-two-text-4.png"
                alt="Clinical team in discussion"
                className="ttc-faq-img w-100 h-100 object-fit-cover"
              />
              {/* <div className="ttc-faq-quote-badge bg-white p-3 p-md-4 rounded-4 position-absolute shadow-sm">
                <blockquote className="ttc-faq-quote-text mb-2">
                  “More than healthcare. A strategy for a life.”
                </blockquote>
                <span className="ttc-faq-quote-author text-uppercase d-block">
                  THE CLINICAL TEAM
                </span>
              </div> */}
            </div>
          </div>

          {/* Right Column: FAQ Title & Accordion */}
          <div className="col-12 col-lg-7 d-flex flex-column justify-content-center">
            
            <div className="ttc-faq-header mb-4">
              <div className="ttc-faq-tagline text-uppercase mb-2 d-flex align-items-center gap-2">
                <span className="ttc-faq-bullet">•</span>
                <span>QUESTIONS</span>
              </div>
              <h2 className="ttc-faq-heading mb-0">
                Frequently asked, <i>plainly answered.</i>
              </h2>
            </div>

            {/* Accordion List */}
            <div className="ttc-accordion-list border-top">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={index} className="ttc-accordion-item border-bottom py-3">
                    <button
                      type="button"
                      className="ttc-accordion-button w-100 d-flex justify-content-between align-items-center text-start border-0 bg-transparent p-0"
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={isOpen}
                    >
                      <span className="ttc-accordion-question pe-3">
                        {faq.q}
                      </span>
                      <span className="ttc-accordion-icon">
                        {isOpen ? '×' : '+'}
                      </span>
                    </button>

                    <div className={`ttc-accordion-collapse ${isOpen ? 'show' : ''}`}>
                      <div className="ttc-accordion-answer pt-3 pb-1">
                        <p className="mb-0">{faq.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}

export default FaqSection;